import axios from "axios";
import {keycloak} from "src/auth";

import {baseUrl} from "src/shared/baseApiUrl";
import {
    removeTokenFromLocalStorage
} from "src/utils/helpers";
import {sendLog} from "src/utils/logger";

class AppService {
    constructor() {
        const request = axios.create({
            baseURL: baseUrl
        });

        request.interceptors.response.use(
            (response) => {
                return response;
            },
            (err) => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled:', err.message);
                    return new Promise(() => {});
                }
                if (err.response.status === 401) {
                    removeTokenFromLocalStorage();
                }
                return Promise.reject(err);
            }
        );

        this.request = request;
    }
    async login(username, password) {
        return new Promise((resolve, reject) => {
            this.request({
                method: "POST",
                url: "v1/user/token",
                data: {username, password},
                credentials: true
            })
                .then((response) => {
                    if (response.status === 200) {
                        resolve({
                            ...response.data.payload,
                            token: response.data.payload.id
                        });
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    sendLog(error);
                    reject(error);
                });
        });
    }

    logout(disabledKeycloak = false) {
        if (!disabledKeycloak) {
            keycloak.logout();
        }
        removeTokenFromLocalStorage();
        localStorage.removeItem("policies");
    }
}

export default AppService;
